import { useContext, useMemo } from 'react';
import { WidgetPlugin } from '../../../types/widgetPlugins';
import { PluginsContext } from '../pluginsContext';

export function usePluginsByInterfaces() {
  const { plugins } = useContext(PluginsContext);

  return useMemo(() => {
    const pluginsMap: Record<string, WidgetPlugin[]> = {};

    for (const plugin of plugins) {
      for (const interfaceName of plugin.pluginInterfaces) {
        if (!pluginsMap[interfaceName]) {
          pluginsMap[interfaceName] = [];
        }
        pluginsMap[interfaceName].push(plugin);
      }
    }

    return pluginsMap;
  }, [plugins]);
}
